module.exports = __webpack_public_path__ + "img/blue-email-envelope.80d3ad73.svg";